import { style } from './../JobLogFolderSection/styles';

export const emailStaterStyle = {
  ...style,
  height: 476,
  width: 422,
};
